import { useNavigate } from "react-router-dom";
import AuthForm from "../../components/AuthForm";
import "./SelectRole.css";

export default function SelectRole() {
  const navigate = useNavigate();

  const fields = [
    {
      type: "radio",
      name: "select_role",
      label: "Company",
      textInput: "For Companies who are seeking Sales Engineers",
      value: "company",
    },
    {
      type: "radio",
      label: "Sales Engineer",
      name: "select_role",
      textInput: "For Sales Engineers who are seeking work",
      value: "sales_engineer",
    },
  ];

  const handleSubmit = (value) => {
    if (value.select_role === "company") {
      navigate("/register/company");
    } else if (value.select_role === "sales_engineer") {
      navigate("/register/professionals");
    }
  };

  return (
    <AuthForm
      fields={fields}
      buttonText="Continue"
      className="select-role"
      title="Select your Role"
      handleSubmit={handleSubmit}
    />
  );
}
